// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getContextCurationNodeBadges: () => Record<string, BadgeInfo> =
    memoize(
        (): Record<string, BadgeInfo> => ({
            rio2016growthmindsetbadge: {
                description: t`Knowledge Games Growth Mindset`,
                extendedDescription: t`Watch at least 30 seconds of any of our growth mindset videos to earn your first medal in the Knowledge Games!`,
            },
            niceplaylisttimebadge: {
                description: t`Nice Listener`,
                extendedDescription: t`Watch 15 minutes of video in a single topic`,
            },
            greatplaylisttimebadge: {
                description: t`Great Listener`,
                extendedDescription: t`Watch 30 minutes of video in a single topic`,
            },
            awesomeplaylisttimebadge: {
                description: t`Awesome Listener`,
                extendedDescription: t`Watch 1 hour of video in a single topic`,
            },
            ridiculousplaylisttimebadge: {
                description: t`Ridiculous Listener`,
                extendedDescription: t`Watch 4 hours of video in a single topic`,
            },
            ludicrousplaylisttimebadge: {
                description: t`Ludicrous Listener`,
                extendedDescription: t`Watch 10 hours of video in a single topic`,
            },
        }),
    );
